import { ComponentsContextProvider, useComponentsContext } from './ComponentsContext';
import { EventContextProvider, useEventContext } from './EventContext';
import { InteractionContextProvider, useInteractionContext } from './InteractionContext';
import { MouseContextProvider, useMouseContext } from './MouseContext';
import { OptionsContextProvider, useOptionsContext } from './OptionsContext';
import { SvgContextProvider, useSvgContext } from './SvgContext';

export {
  useComponentsContext,
  useEventContext,
  useInteractionContext,
  useMouseContext,
  useOptionsContext,
  useSvgContext,
};

// if a custom component with the SAME NAME has passed
// this hoc will replace the wrapped "Default" component with the custom one
export const withComponentsContext = (Default: any, name: any) => (props: any) => {
  const customComponents = useComponentsContext();
  // const name = Default.displayName || Default.name || Default.type?.name; // does not work on production
  const Component = customComponents[name] ?? Default;
  return <Component {...props} />;
};

export const ContextProvider = ({
  minWidth,
  height,
  components,
  children,
  // options
  hideSelected = false,
  selectShift = false,
  selectToggle = false,
}: any) => (
  <ComponentsContextProvider components={components}>
    <OptionsContextProvider hideSelected={hideSelected}>
      <SvgContextProvider minWidth={minWidth} height={height}>
        <InteractionContextProvider selectShift={selectShift} selectToggle={selectToggle}>
          <MouseContextProvider>
            <EventContextProvider>{children}</EventContextProvider>
          </MouseContextProvider>
        </InteractionContextProvider>
      </SvgContextProvider>
    </OptionsContextProvider>
  </ComponentsContextProvider>
);
